import React from "react";
import { isParent } from "./functions/isParent";

const useFindDependedItems = (fields) => {
  const findRootNodes = (fields) => {
    const findChildren = (parent) => {
      return fields
        .map((field) => {
          if (
            field.element.ElsRecord.IdParent === parent.element.ElsRecord.Id //if they are child of some element
          ) {
            return {
              ...field,
              Children: findChildren(field),
              parentIndex: parent.iddetail,
            };
          }
        })
        .filter((f) => f);
    };

    return fields.map((field) => {
      if (isParent(field)) {
        // if the element is parent
        return {
          ...field,
          Children: findChildren(field),
        };
      }
      return { ...field };
    });
  };

  const rootNodes = findRootNodes(fields).filter((f) => f);
  const filterRootNodes = (rootNodes) => {
    const findChildrenIds = (nodes) => {
      return nodes.reduce((acc, curr) => {
        // If the current node has children, add their ids and recursively find their children's ids
        if (Array.isArray(curr.Children) && curr.Children.length > 0) {
          return [
            ...acc,
            ...curr.Children.map((el) => el.element.ElsRecord.Id), // in recursion, you add the original value and its operation
            ...findChildrenIds(curr.Children), // then you repeat the cycle.
          ];
        }

        return [...acc, curr];
      }, []);
    };
    const childIds = findChildrenIds(rootNodes);
    return rootNodes?.filter(
      (node) => !childIds.includes(node.element.ElsRecord.Id)
    );
  };
  const filteredRootNodes = filterRootNodes(rootNodes);

  return [filteredRootNodes];
};

export default useFindDependedItems;
